import { render, staticRenderFns } from "./warehousingreportmanagementcenter.vue?vue&type=template&id=64047c16&scoped=true&"
import script from "./warehousingreportmanagementcenter.vue?vue&type=script&lang=js&"
export * from "./warehousingreportmanagementcenter.vue?vue&type=script&lang=js&"
import style0 from "./warehousingreportmanagementcenter.vue?vue&type=style&index=0&id=64047c16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64047c16",
  null
  
)

export default component.exports